import { WrapKontomatik } from '@components/Generic'

import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { setUrlParam } from '@/methods/urlParams'
import { API_URL } from '@/constants/apiUrl'

export const KontomatikPage = observer(() => {
  const store = useContext(StoreContext)
  const { language } = store.TranslationsState

  const [kontomatikSelectedBank, setKontomatikSelectedBank] = useState('')

  const getKontomatikContext = async (): Promise<void> => {
    try {
      const res = await axiosInstance.get(`${API_URL}/kontomatik/get-context`, {
        withCredentials: true,
      })

      const { providerClientId, bankStatementUpload } = res.data

      setUrlParam('shouldUploadBankStatement', bankStatementUpload.toString())

      window.embedKontomatik({
        client: providerClientId,
        fluidWidth: true,
        divId: 'kontomatik',
        locale: language,
        onUnsupportedTarget: function () {
          store.ScenarioState.nextPage()
          setKontomatikSelectedBank('other')
          setUrlParam('kontomatikSelectedBank', 'other')
          setUrlParam('shouldUploadBankStatement', 'true')
        },
        onSuccess: function (_, sessionId, sessionIdSignature) {
          axiosInstance.post(
            `${API_URL}/kontomatik/authentication-complete`,
            {
              sessionId: sessionId,
              sessionIdSignature: sessionIdSignature,
            },
            {
              withCredentials: true,
            }
          )

          store.ScenarioState.nextPage()
        },
        onTargetSelected: (name) => {
          setKontomatikSelectedBank(name)
          setUrlParam('kontomatikSelectedBank', name)
        },
      })
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    getKontomatikContext()
  }, [])

  useEffect(() => {
    if (
      kontomatikSelectedBank === 'Pko' ||
      kontomatikSelectedBank === 'Inteligo' ||
      kontomatikSelectedBank === 'PkoApi'
    ) {
      setUrlParam('kontomatikSelectedBank', 'pko')
      setUrlParam('shouldUploadBankStatement', 'true')

      store.ScenarioState.nextPage()
    }
  }, [kontomatikSelectedBank])

  return (
    <WrapKontomatik>
      <div id="kontomatik" />
    </WrapKontomatik>
  )
})
